export default {
  provide () {
    return { tableColumnsState: this.$data._tableColumnsState }
  },
  data: () => ({
    _tableColumnsState: {
      state: ''
    }
  }),
  computed: {
    tableColumnsState_state: {
      get: ({ $data }) => $data._tableColumnsState.state,
      set (state = '') {
        this.$data._tableColumnsState.state = state
      }
    }
  }
}
